import {Pipe, PipeTransform} from '@angular/core'
import {RegionalIndustry} from '../../../../core/content/types/craftsmen-region-types'
import {RelatedItem} from '../../../../shared/components/content/related-items-section/related-items-section.component'
import {LinkService} from '../../../../core/i18n/link.service'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'

@Pipe({
  name: 'mapRelatedIndustries',
  standalone: true,
})
export class MapRelatedIndustriesPipe implements PipeTransform {
  constructor(private readonly linkService: LinkService) {}

  transform(industries: RegionalIndustry[], regionSlug: string): RelatedItem[] {
    return industries.map(industry => ({
      id: industry.slug,
      name: industry.label,
      link: this.linkService.localizedPathTo(PUBLIC_ROUTES.CRAFTSMEN_REGION_INDUSTRY_PAGE, {
        routeParams: {regionSlug, industrySlug: industry.slug},
      }),
    }))
  }
}
